import { createClient } from "@supabase/supabase-js";
import { Preferences } from "@capacitor/preferences";
import { Capacitor } from "@capacitor/core";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  console.warn("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY — copy .env.example to .env and fill them in.");
}

// FAZA 22 — rregullim "duhet login çdo herë në Android". Shkaku: pa këtë,
// supabase-js përdor `localStorage` të thjeshtë për të ruajtur sesionin —
// dhe sistemet operative mobile (Android/iOS) PERIODIKISHT PASTROJNË
// localStorage-in e WebView-it (i dokumentuar zyrtarisht nga vetë
// Capacitor: "Mobile OSs may periodically clear data set in
// window.localStorage"). Kjo e bënte sesionin të "zhdukej" në mënyrë të
// paparashikueshme, duke detyruar rilogim të shpeshtë, edhe pse refresh
// token-i teorikisht duhej të ishte ende i vlefshëm.
//
// Zgjidhja: `@capacitor/preferences` — ruajtje NATIVE (SharedPreferences në
// Android, UserDefaults në iOS), e cila NUK pastrohet automatikisht nga OS
// (fshihet vetëm nëse vetë app-i çinstalohet). Në web (jo brenda Capacitor),
// kjo API bie automatikisht mbrapa te localStorage — pra s'ndryshon asgjë
// për përdoruesit e web-it, thjesht e bën më të qëndrueshëm rastin mobile.
const capacitorPreferencesStorage = {
  getItem: async (key) => {
    const { value } = await Preferences.get({ key });
    return value;
  },
  setItem: async (key, value) => {
    await Preferences.set({ key, value });
  },
  removeItem: async (key) => {
    await Preferences.remove({ key });
  },
};

export const supabase = createClient(url, key, {
  auth: {
    storage: capacitorPreferencesStorage,
    persistSession: true,
    autoRefreshToken: true,
    // FIX — "false" ishte i vendosur PËRHERË, jo vetëm brenda Capacitor siç
    // synohej te komenti origjinal (FAZA 22 më lart) — kjo e prishte OAuth-in
    // (Google/Apple) EDHE në web: pas kthimit nga Google me token-in te URL-ja,
    // supabase-js kurrë s'e lexonte (detectSessionInUrl=false e injoron
    // krejtësisht), kështu që personi kthehej te platforma pa u loguar,
    // pavarësisht se Google-i vetë funksiononte normalisht. Tani: e lexon URL-në
    // (true) VETËM në web, ku është e domosdoshme për OAuth — mbetet e
    // çaktivizuar (false) brenda app-it Capacitor (Android/iOS), pikërisht
    // siç synohej fillimisht, ku login-i bëhet me email+fjalëkalim, jo OAuth.
    detectSessionInUrl: !Capacitor.isNativePlatform(),
  },
});
